import { turnitinService } from "../services/turnitin.service";

const state = {
	loading: false,
};

const getters = {

};

const actions = {

	// returns null when the call fails, so callers can fail closed rather than
	// treating an unknown EULA state as accepted
	getSimilarityEula: async ({ commit }, { lang }) => {
		commit("setLoading", true);
		var eulaStatus = await turnitinService.getSimilarityEula(lang)
		.then(
			(eulaStatus) => {
				commit("setLoading", false);
				return eulaStatus.payload;
			},
			(error) => {
				commit("setLoading", false);
				return null;
			}
		);
		return eulaStatus;
	},
	acceptSimilarityEula: async ({ commit }, { version, language }) => {
		commit("setLoading", true);
		var accepted = await turnitinService.acceptSimilarityEula(version, language)
		.then(
			(response) => {
				commit("setLoading", false);
				return response && response.status == "Success";
			},
			(error) => {
				commit("setLoading", false);
				return false;
			}
		);
		return accepted;
	},
	getSimilarityViewerUrl: async ({ commit }, { contentId, userId, turnitinSubmissionId }) => {
		commit("setLoading", true);
		var viewerUrl = await turnitinService.getSimilarityViewerUrl(contentId, userId, turnitinSubmissionId)
		.then(
			(response) => {
				commit("setLoading", false);
				return response ? response.payload : null;
			},
			(error) => {
				commit("setLoading", false);
				return null;
			}
		);
		return viewerUrl;
	}
};

const mutations = {
	setLoading(state, data) {
		state.loading = data;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
